export default "__VITE_ASSET__6gXhWJRV__"